import { BaseClient } from '../../lib';
export class CreditsClient extends BaseClient {
    url;
    constructor(url, config) {
        super(url, config);
        this.url = url;
    }
    /**
     * Fetches the credits for a user
     * @param address - The user's address
     * @returns The credits for the user
     */
    async fetchCredits(address) {
        try {
            const response = await this.fetch(`/users/${address}/credits`);
            return response;
        }
        catch (error) {
            console.error('Error fetching credits', error);
            return { credits: [], totalCredits: 0 };
        }
    }
    /**
     * Fetches the current season data
     * @returns The season data
     */
    async fetchSeason() {
        try {
            const response = await this.fetch('/season');
            return response;
        }
        catch (error) {
            console.error('Error fetching season data', error);
            return null;
        }
    }
    /**
     * Creates an SSE connection with reconnection logic
     * @param address - The user's address
     * @param onMessage - Callback function for received messages
     * @param onError - Callback function for errors
     * @returns Object with close method to manually disconnect
     */
    createSSEConnection(address, onMessage, onError) {
        let eventSource = null;
        let retryCount = 0;
        let reconnectTimeout = null;
        const MAX_RETRIES = 5;
        const RETRY_DELAY_MS = 3000;
        const connect = () => {
            if (eventSource) {
                // Close existing connection before creating a new one
                eventSource.close();
                eventSource = null;
            }
            eventSource = new EventSource(`${this.url}/users/${address}/credits/stream`);
            eventSource.onopen = () => {
                // Reset retry count on successful connection
                retryCount = 0;
                console.log('SSE connection established');
            };
            eventSource.onmessage = event => {
                try {
                    const data = JSON.parse(event.data);
                    onMessage(data);
                }
                catch (error) {
                    console.error('Error parsing SSE event data:', error);
                }
            };
            eventSource.onerror = error => {
                console.error('SSE connection error:', error);
                // Close the connection
                if (eventSource) {
                    eventSource.close();
                    eventSource = null;
                }
                // Attempt to reconnect if under max retries
                if (retryCount < MAX_RETRIES) {
                    retryCount++;
                    console.log(`Reconnecting SSE (attempt ${retryCount}/${MAX_RETRIES})...`);
                    // Store timeout ID so we can cancel it if needed
                    reconnectTimeout = window.setTimeout(connect, RETRY_DELAY_MS);
                }
                else {
                    console.error(`Max SSE reconnection attempts (${MAX_RETRIES}) reached`);
                    onError(error);
                }
            };
        };
        // Initial connection
        connect();
        // Return an object with a close method to allow manual disconnection
        return {
            close: () => {
                // Clear any pending reconnection attempts
                if (reconnectTimeout !== null) {
                    window.clearTimeout(reconnectTimeout);
                    reconnectTimeout = null;
                }
                // Close the EventSource if it exists
                if (eventSource) {
                    eventSource.close();
                    eventSource = null;
                }
            }
        };
    }
}
//# sourceMappingURL=CreditsClient.js.map